import { Controller } from 'stimulus'

// Tooltip acessivel do nome do produto truncado (`.ch-text--truncate` no figcaption,
// `app/views/orders/_items.html.erb`). Baseado em `compound_overlay_controller.js`:
// mesmo motivo para `position: fixed` (a celula do item e um grid com `max-width: 33vw`
// e cortaria a tooltip no fluxo) e mesma estrategia de reposicionamento e limpeza de
// listeners no `disconnect`.
//
// Abre em 3 entradas porque nenhuma sozinha cobre todo mundo: `mouseenter`/`mouseleave`
// nao existem em touch, e `focus`/`blur` sao o unico sinal de teclado disponivel num
// elemento sem acao nativa (nao e botao nem link). `touchstart` cobre o toque porque
// tocar um `<span>` nao garante foco em todo navegador mobile.
//
// `locked` existe para o `mouseleave` nao fechar uma tooltip aberta por toque, no caso
// hibrido (notebook touchscreen) de o cursor estar em cima do elemento tocado.
const GAP = 8

export default class extends Controller {
  static targets = ['trigger', 'content']

  connect() {
    this.locked = false
    document.addEventListener('click', this.closeOnOutsideClick)
    document.addEventListener('keydown', this.closeOnEscape)
    window.addEventListener('resize', this.reposition)
    // `true` para capturar scroll de qualquer container, e nao so do window: a tabela
    // de itens rola dentro do painel da aba.
    window.addEventListener('scroll', this.reposition, true)
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutsideClick)
    document.removeEventListener('keydown', this.closeOnEscape)
    window.removeEventListener('resize', this.reposition)
    window.removeEventListener('scroll', this.reposition, true)
  }

  get isOpen() {
    return !this.contentTarget.hidden
  }

  show = () => {
    this.contentTarget.hidden = false
    this.reposition()
  }

  hide = () => {
    this.contentTarget.hidden = true
    this.locked = false
  }

  onMouseEnter = () => this.show()

  onMouseLeave = () => {
    if (!this.locked) this.hide()
  }

  onFocus = () => this.show()

  onBlur = () => this.hide()

  toggle = () => {
    this.locked = !this.isOpen
    if (this.isOpen) this.hide()
    else this.show()
  }

  closeOnEscape = event => {
    if (event.key === 'Escape' && this.isOpen) this.hide()
  }

  // Sem `stopPropagation`: o clique precisa chegar ao `document` para que as *outras*
  // tooltips da tabela (uma instancia por item) o vejam como externo e fechem.
  closeOnOutsideClick = event => {
    if (!this.isOpen) return
    if (this.element.contains(event.target)) return

    this.hide()
  }

  // Abre abaixo do texto por padrao; sobe quando nao ha espaco ate o fim da viewport.
  // Alinha pela esquerda do gatilho e recua se passar da borda direita -- mesma logica
  // de `compound_overlay_controller.js#reposition`.
  reposition = () => {
    if (!this.isOpen) return

    const trigger = this.triggerTarget.getBoundingClientRect()
    const content = this.contentTarget
    const { offsetWidth: width, offsetHeight: height } = content

    let top = trigger.bottom + GAP
    if (top + height > window.innerHeight && trigger.top - height - GAP > 0) {
      top = trigger.top - height - GAP
    }

    const maxLeft = window.innerWidth - width - GAP
    const left = Math.max(GAP, Math.min(trigger.left, maxLeft))

    content.style.top = `${top}px`
    content.style.left = `${left}px`
  }
}
